import React from 'react'
import PropTypes from 'prop-types'

const CheckCircleOutlineIcon = (props) => {
  const { color = '#22C55E', classes = 'w-20' } = props
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.125 -0.00683594C4.87841 -0.00683594 0.625 4.24657 0.625 9.49316C0.625 14.7398 4.87841 18.9932 10.125 18.9932C15.3716 18.9932 19.625 14.7398 19.625 9.49316C19.625 4.24657 15.3716 -0.00683594 10.125 -0.00683594ZM14.2428 7.8868C14.3186 7.80013 14.3764 7.69917 14.4126 7.58986C14.4488 7.48054 14.4628 7.36509 14.4538 7.25029C14.4447 7.13548 14.4128 7.02365 14.3599 6.92137C14.307 6.81908 14.2342 6.72841 14.1457 6.65469C14.0572 6.58096 13.9549 6.52568 13.8448 6.49208C13.7346 6.45849 13.6189 6.44726 13.5043 6.45906C13.3898 6.47086 13.2787 6.50545 13.1777 6.5608C13.0767 6.61615 12.9879 6.69113 12.9163 6.78135L9.20264 11.2368L7.28105 9.31439C7.11816 9.15707 6.90001 9.07002 6.67356 9.07199C6.44712 9.07396 6.23051 9.16479 6.07038 9.32491C5.91026 9.48504 5.81943 9.70165 5.81746 9.92809C5.8155 10.1545 5.90255 10.3727 6.05986 10.5356L8.65077 13.1265C8.73563 13.2113 8.83723 13.2775 8.94909 13.3209C9.06094 13.3642 9.18061 13.3838 9.30046 13.3784C9.42031 13.3729 9.53771 13.3426 9.64517 13.2892C9.75264 13.2359 9.84782 13.1608 9.92464 13.0686L14.2428 7.8868Z"
        fill={color}
      />
    </svg>
  )
}

CheckCircleOutlineIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(CheckCircleOutlineIcon)
